export const USER_DETAILS = "USER_DETAILS";

export const setAuthData = (data: any) => ({ type: USER_DETAILS, payload: data });
